import { FormLabel } from "@chakra-ui/react";
import { FunctionComponent } from "react";

type AddressBookLabelProps = {
  id: string;
  label: string;
  requiredIndicator?: React.ReactElement;
};

export const AddressBookLabel: FunctionComponent<AddressBookLabelProps> = (
  props
) => {
  const { id, label, requiredIndicator } = props;
  return (
    <FormLabel
      fontSize="sm"
      htmlFor={id}
      display="flex"
      gap={3}
      alignItems="center"
      fontWeight="500"
      requiredIndicator={requiredIndicator}
    >
      {label}
    </FormLabel>
  );
};
